/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementEditMailMagazineResponse } from './MailMagazineManagementEditMailMagazineResponse';

export type MailMagazineManagementEditMailMagazineResponseApiRespoonse = {
    data?: MailMagazineManagementEditMailMagazineResponse;
    status?: MailMagazineManagementEditMailMagazineResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MailMagazineManagementEditMailMagazineResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

